export default __webpack_public_path__ + "static/media/empathic.64e129f0.png";